/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global";
	import * as helper from "../../../js/helper";
	import full_loading from "../../components/full-loading.vue";
	import sale_report_component from "../../components/dashboard/sale-report-component.vue";
	import rent_report_component from "../../components/dashboard/rent-report-component.vue";
	import projects_dashboard_component from "../../components/dashboard/projects-dashboard-component.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            sale_report_component:sale_report_component,
            rent_report_component:rent_report_component,
            projects_dashboard_component:projects_dashboard_component,
        },
		name:'dashboard_widget',
        props: { 
            show_shared: {
                type: Boolean,
                default:false
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                dash_type:'Properties',
                is_loading:false,
                is_ready:false,
				properties: [],
                agencies: [],
                members: [],
                search_filters: localStorage.dashboard_search_filters
                    ? JSON.parse(localStorage.dashboard_search_filters)
                    : {},
			}
		},
        async beforeMount(){
            if(this.search_filters.selected_agency == undefined){
                this.search_filters.selected_agency = "";
            }
            if(this.search_filters.selected_member == undefined){
                this.search_filters.selected_member = "";
            }
            if(frappe.user_roles.includes('Agency')){
                await this.load_members();
            }else if(frappe.user_roles.includes('Member')){
                await this.load_agencies();
            }
            if(!frappe.user_roles.includes('Member')){
                this.search_filters.selected_agency = ""
                localStorage.dashboard_search_filters = JSON.stringify(
                    this.search_filters
                );
            }
            if(!frappe.user_roles.includes('Agency')){
                this.search_filters.selected_member = ""
                localStorage.dashboard_search_filters = JSON.stringify(
                    this.search_filters
                );
            }
            this.is_ready = true;
        },
        mounted(){
        },
		methods: {
            load_agencies: async function(reload=true){
                if(reload){
                    while(this.agencies.length > 0) {
                        this.agencies.pop();
                    }
                }
                let params = {};
                let url = "/api/method/maalek.api.get_registered_agencies";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                for (let index = 0; index < res.message.length; index++) {
                    this.agencies.push(res.message[index]);
                }
                if(this.search_filters.selected_agency.length > 0){
                    if(this.agencies.find((agency)=>agency.agency == this.search_filters.selected_agency) == undefined){
                        this.search_filters.selected_agency = ""
                        localStorage.dashboard_search_filters = JSON.stringify(
                            this.search_filters
                        );
                    }
                }
            },
            load_members: async function(reload=true){
                if(reload){
                    while(this.agencies.length > 0) {
                        this.agencies.pop();
                    }
                }
                let params = {};
                let url = "/api/method/maalek.api.get_agency_members";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                for (let index = 0; index < res.message.length; index++) {
                    this.members.push(res.message[index]);
                }
                if(this.search_filters.selected_member.length > 0){
                    if(this.members.find((member)=>member.member == this.search_filters.selected_member) == undefined){
                        this.search_filters.selected_member = ""
                        localStorage.dashboard_search_filters = JSON.stringify(
                            this.search_filters
                        );
                    }
                }
            },
            update_dashboard: function(){
                localStorage.dashboard_search_filters = JSON.stringify(
                    this.search_filters
                );
                global.emitter.emit("update-dashboard");
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-listing" },
    [
      _c("div", { staticClass: "row pt-2" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("nav", { staticClass: "nav nav-pills nav-fill d-flex flex-row" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                class: _vm.dash_type == "Properties" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    _vm.dash_type = "Properties"
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.helper.t("Property Listings")) +
                    "\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nav-link",
                class: _vm.dash_type == "Projects" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    _vm.dash_type = "Projects"
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.helper.t("Projects")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      this.agencies.length > 0
        ? _c("div", { staticClass: "d-flex justify-content-end mb-4" }, [
            _c(
              "div",
              {
                staticClass: "btn-toolbar",
                attrs: {
                  role: "toolbar",
                  "aria-label": "Toolbar with button groups"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "btn-group me-2", attrs: { role: "group" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "filter-label" }, [
                        _vm._v(_vm._s(_vm.helper.t("Filter by")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search_filters.selected_agency,
                              expression: "search_filters.selected_agency"
                            }
                          ],
                          staticClass: "form-select",
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.search_filters,
                                  "selected_agency",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.update_dashboard()
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "", selected: "" } }, [
                            _vm._v(
                              _vm._s(_vm.helper.t("Your Private Dashboard"))
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.agencies, function(agency) {
                            return _c(
                              "option",
                              { domProps: { value: agency["agency"] } },
                              [_vm._v(_vm._s(agency["full_name"]))]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      this.members.length > 0
        ? _c("div", { staticClass: "d-flex justify-content-end mb-4" }, [
            _c(
              "div",
              {
                staticClass: "btn-toolbar",
                attrs: {
                  role: "toolbar",
                  "aria-label": "Toolbar with button groups"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "btn-group me-2", attrs: { role: "group" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "filter-label" }, [
                        _vm._v(_vm._s(_vm.helper.t("Filter by")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search_filters.selected_member,
                              expression: "search_filters.selected_member"
                            }
                          ],
                          staticClass: "form-select",
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.search_filters,
                                  "selected_member",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.update_dashboard()
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "", selected: "" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Agency Dashboard")))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.members, function(member) {
                            return _c(
                              "option",
                              { domProps: { value: member["member"] } },
                              [_vm._v(_vm._s(member["full_name"]))]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.is_ready && _vm.dash_type == "Properties"
        ? [
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("sale_report_component", {
                    attrs: { search_filters_prop: _vm.search_filters }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("rent_report_component", {
                    attrs: { search_filters_prop: _vm.search_filters }
                  })
                ],
                1
              )
            ])
          ]
        : _vm.is_ready && _vm.dash_type == "Projects"
        ? [
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("projects_dashboard_component", {
                    attrs: { search_filters_prop: _vm.search_filters }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-dc53d55a_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"dashboard-widget.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/dashboard-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__